export const availableParts = [141, 61];
export type AvailableParts = typeof availableParts[number];
export const defaultPart: AvailableParts = 141;

export type Certificate = {
    uuid: string;
    acronym: string;
    title: string;
    part: AvailableParts;
    hoursRequired?: number;
};
